import React from 'react'

const HeaderSocials = () => {
  return (
    <div className='home__socials'>
        <a href="https://www.instagram.com/jielim0723/" className="home__socials-link" target='_blank'>
            <i class="fa-brands fa-instagram"></i>
        </a>
        <a href="https://github.com/jielim36" className="home__socials-link" target='_blank'>
            <i class="fa-brands fa-github"></i>        
        </a>
        <a href="https://www.linkedin.com/in/lim-yee-jie/" className="home__socials-link" target='_blank'>
            <i class="fa-brands fa-linkedin"></i>
        </a>
        <a href="https://medium.com/@jielim36" className="home__socials-link" target='_blank'>
        <i class="fa-brands fa-medium"></i>
        </a>
    </div>
  )
}

export default HeaderSocials